/**
 * CopyChip — real-time tap-to-copy button. Briefly flips to a green
 * "✓ COPIED" pill for ~1.1s so the user gets instant visual feedback
 * on the tapped element itself (in addition to the toast).
 *
 * Extracted from Chat.jsx (Feb 2026) so ResendModal / StaffSheetsModal
 * and future subcomponents can reuse it without pulling in the full
 * Chat.jsx surface. Behaviour is UNCHANGED — pure code move.
 */
import React from "react";
import { copyDigits } from "@/lib/clipboard";

export default function CopyChip({ value, testId, label, className = "", flashClassName = "" }) {
  const [flash, setFlash] = React.useState(false);
  const handle = (ev) => {
    ev.stopPropagation();
    const ok = copyDigits(value);
    if (!ok) return;
    setFlash(true);
    window.setTimeout(() => setFlash(false), 1100);
  };
  return (
    <button
      type="button"
      onClick={handle}
      data-testid={testId}
      title="Tap to copy — sirf digits, max 17"
      className={`inline-flex items-center gap-2 cursor-pointer bg-transparent border-0 p-0 font-mono transition-colors duration-150 ${className}`}
    >
      {flash ? (
        <span
          className={`px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 text-[11px] tracking-widest font-bold animate-pulse ${flashClassName}`}
          data-testid={`${testId}-copied-flash`}
        >
          ✓ COPIED
        </span>
      ) : (
        <span>{label ?? value}</span>
      )}
    </button>
  );
}
